import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  accordionSummary: {
    width: '100%',
  },
  dataGridWrapper: {
    overflowX: 'hidden',
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'hidden !important',
      minHeight: '30px',
    },
    '& .MuiDataGrid-row.Mui-selected': {
      backgroundColor: 'transparent',
    },
  },
  estateTaskDataGrid: {
    '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
      display: 'none',
    },
    '& .estateTasksHeader': {
      backgroundColor: '#F5F5F5',
    },
    '& .checkbox-column': {
      backgroundColor: '#F5F5F5',
    },
    '& .MuiDataGrid-row': {
      minHeight: 60,
    },
    '& .MuiDataGrid-cell': {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
    width: '100%',
    border: 'none',
    overflowY: 'auto',
    maxHeight: theme.spacing(80),
  },
  sectionHeader: {
    width: '100%',
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(2),
  },
  addTaskButton: {
    width: theme.spacing(14),
    height: theme.spacing(5.7),
    padding: 0,
    marginRight: theme.spacing(1),
    borderRadius: 25,
    fontSize: '13px',
    backgroundColor: '#5ED1F0',
  },
  showHiddenTasksButton: {
    width: theme.spacing(20),
    height: theme.spacing(5.7),
    padding: 0,
    color: '#1C2541',
    marginRight: theme.spacing(3),
    border: '1px solid black',
    fontSize: '13px',
    borderRadius: 25,
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: '#5ED1F0',
      border: 0,
    },
  },
}));
